import { useMutation, useQuery } from "@tanstack/react-query";

import { Button, Col, DatePicker, Descriptions, Divider, Drawer, Form, message, Row, Select } from "antd";
import axios from "axios";
import dayjs from "dayjs";
import { forwardRef, useImperativeHandle, useState } from "react";
import { hostname, ISO8601 } from "../hooks/useEndeavour";
import DataTable from "./DataTable";
import Status from "../components/Status";

const UserBindingNotificationsDetailDrawer = forwardRef((props, ref) => {
  const [form] = Form.useForm();
  const [open, setOpen] = useState(false);
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const [forceUpdate, setForceUpdate] = useState(0);
  const [id, setID] = useState();
  const reject_user = useMutation({
    mutationFn: (value) => {
      return axios
        .post(`${hostname}/pa-alliance/notification/template/task/${data?.task_id}/reject`, value, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        })
        .then((res) => {
          if (res.status != 200) {
            message.error("Reject Fail");
          }
          message.success("Reject Success");
          setLoading(false);
        })
        .finally(() => {
          setLoading(false);
        });
    },
  });

  const openDrawer = (data) => {
    console.log(data.task_id);
    setData(data);
    setOpen(true);
  };

  const closeDrawer = () => {
    setOpen(false);
    setLoading(false);
    form.resetFields();
  };

  useImperativeHandle(ref, () => ({
    openDrawer,
  }));

  return (
    <Drawer title="Notifications Information" open={open} onClose={closeDrawer} width={"800px"}>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <Descriptions column={2} layout="vertical">
            <Descriptions.Item label="Title">{data?.title}</Descriptions.Item>
            <Descriptions.Item label="Type">{data?.type}</Descriptions.Item>

            <Descriptions.Item label="Channel">{data?.channel}</Descriptions.Item>
            <Descriptions.Item label="Prompt">
              <pre style={{ margin: 0, whiteSpace: "pre-wrap" }}>{JSON.stringify(data?.prompt, null, 2)}</pre>
            </Descriptions.Item>
            <Descriptions.Item label="Body">{data?.body}</Descriptions.Item>
          </Descriptions>

          <Divider orientation="left">Bound User</Divider>
          {`${data?.id}/task/${data?.task_id}/users`}
          <DataTable
            uri={`${hostname}/pa-alliance/notification/template/${data?.id}/task/${data?.task_id}/users`}
            ForceUpdate={forceUpdate}
            tableColumns={[
              {
                title: "Email",
                render: (item) => {
                  return item.user_email;
                },
              },
              {
                title: "Status",
                render: (item) => {
                  return <Status value={item.status} />;
                },
              },

              {
                title: "Created At",
                render: (item) => {
                  return ISO8601(item.created_at);
                },
              },
              {
                title: "Updated At",
                render: (item) => {
                  return ISO8601(item.updated_at);
                },
              },
              {
                title: "Action",
                render: (item) => {
                  if (item.status !== "approve") {
                    return (
                      <Button
                        style={{ backgroundColor: "red", color: "#FFFFFF" }}
                        loading={loading}
                        onClick={() => {
                          reject_user.mutate(item);
                        }}
                      >
                        Reject
                      </Button>
                    );
                  }
                },
              },
            ]}
          />
        </Col>
      </Row>
    </Drawer>
  );
});

export default UserBindingNotificationsDetailDrawer;
